import React from 'react';
import SimpleTable from 'modules/Tables/SimpleTable';
import LoadingBar from '@hubins/components/LoadingIndicators';
import BackofficeProfileLink from '@hubins/components/BackofficeProfileLink';
import BackofficePortfolioLink from '../BackofficePortfolioLink/BackofficePortfolioLink';

const headers = [
  {
    Header: '',
    accessor: 'title',
  },
  {
    Header: '',
    accessor: 'value',
  },
];

type Props = {
  portfolio: any;
  loading: boolean;
  risk: number;
  importedFmaCategory: number;
};

const BusinessProfilePortfolioTable = ({ portfolio, loading, risk, importedFmaCategory }: Props) => {

  const data = [
    {
      title: 'Policy Number',
      value: <BackofficePortfolioLink key={portfolio.uuid} portfolioUuid={portfolio.uuid} profileUuid={portfolio.policy_holder[0].uuid}>
        {portfolio.short_name}
      </BackofficePortfolioLink>
    },
    {
      title: 'Risk Categorization',
      value: loading ? <LoadingBar small /> : risk
    },
    {
      title: 'Imported Risk Categorization from FA',
      value: loading ? <LoadingBar small /> : importedFmaCategory
    },
    {
      title: 'Policy Holder',
      value: portfolio.policy_holder.map((user, index) => {
        return (
          <>
            <BackofficeProfileLink key={user.uuid} profileUuid={user.uuid}>
              {user.name}
            </BackofficeProfileLink>
            {index < portfolio.policy_holder.length - 1 && <br />}
          </>
        );
      })
    },
    {
      title: 'Is the policyholder the same as the beneficial owner of the policy?',
      value: 'Yes'
    },

  ]

  return (
    <div className='s-top-xl s-bottom-xl'>
      <SimpleTable
        headers={headers}
        data={data}
      />
    </div>
  )
};

export default BusinessProfilePortfolioTable;